import { Injectable } from '@angular/core';

const { DateTime } = require("luxon");

@Injectable()
export class Luxon {
    TimeZone = 'local';

    constructor() {
        this.init()
        console.log('Just your friendly neighborhood Luxon Man in ', this.TimeZone);
    }

    init() {
        let user = JSON.parse(window.localStorage.getItem('sessionData'));
        // console.warn('User:', user)
        this.TimeZone = user && user.Timezone ? user.Timezone : this.TimeZone;
    }

    changeTZ(zone) {
        this.TimeZone = zone;
        console.log('TZ changed to: ', this.TimeZone);
    }

    now () {
        return DateTime.local().setZone(this.TimeZone);
    }

    fromISO (value) {
        return DateTime.fromISO(value, { zone: this.TimeZone })
    }

    fromHTTP (value) {
        return DateTime.fromHTTP(value, { zone: this.TimeZone })
    }

    fromRFC2822 (value) {
        return DateTime.fromRFC2822(value, { zone: this.TimeZone })
    }

    nowUtc () {
        return DateTime.utc()
    }

    fromFormat (value, format) {
        return DateTime.fromFormat(value, format)
    }

    short () {
        return DateTime.DATETIME_SHORT
    }

}



// WEBPACK FOOTER //
// ./src/providers/datetime-service/datetime-service.ts